import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-router-dom'
import Application from "../../../StateContext/Application"
// import { Excel11, failed, PDF11, pending, success, Winnericon32 } from '../../../../../public/LoginImages/importimages'
import { apiurl } from '../../../../../path'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import iconSrc from "../../../../../public/LoginImages/Dashboard32.png"

const ECSTransferFiles = () => {

    const statecalls = useContext(Application)
    const { FetchECSFiles, FetchECSFilesForTransfer, FetchECSReport, FetchECSDashboardReport, getEcsFiles, SendFund } = statecalls;
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, SetFileName] = useState([])
    const [ecsdata, SetECSData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(ecsdata.length / itemsPerPage);
    const paginatedData = ecsdata.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    useEffect(() => {
        GetAllECSFiles();
    }, [])

    async function GetAllECSFiles(token) {
        try {
            let data = await FetchECSFilesForTransfer(token);
            SetECSData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.log(error);
            SetECSData([]);
        }
    }

    const handleSelect = (fileName) => {
        setSelectedFile(fileName);
    };

    const handleSendFunds = async () => {
        if (!selectedFile) {
            alert("Please select at least one file");
            return;
        }
        if (isLoading) return;
        try {
            setIsLoading(true);
            const res = await SendFund([selectedFile]);
            console.log(res);
            if (res?.message) {
                alert(res.message);
            }
            window.location.reload()
        } catch (error) {
            console.log(error);
            alert("Something went wrong");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <h4 style={{ margin: '30px' }}>ECS Transfer Files</h4>
            <div style={{ padding: '2rem' }}>
                <div style={{ padding: "20px", overflow: "auto", backgroundColor: '#f5f9fc' }}>
                    <div style={{ display: "grid", borderRadius: "20px", padding: "20px", backgroundColor: 'white' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
                                <h5 style={{ paddingTop: '10px' }}>Generated ECS Files</h5>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', paddingBottom: '10px' }}>
                                <button onClick={handleSendFunds} disabled={isLoading} style={{ padding: "8px 16px", backgroundColor: isLoading ? "#999" : "#2C78DB", color: "white", border: "none", borderRadius: "5px", cursor: isLoading ? "not-allowed" : "pointer", marginBottom: "10px" }} >  {isLoading ? "Processing..." : "Transfer File"} </button>
                            </div>
                        </div>
                        <div className="table-responsive" style={{ width: '96%', margin: '0 auto', }}>
                            <table className="project-table" style={{ backgroundColor: '#e8f7f3', width: '100%', borderCollapse: "collapse" }}>
                                <thead style={{ background: '#2C78DB', color: 'white' }}>
                                    <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
                                        <th>Select File </th>
                                        <th>Sr.No.</th>
                                        <th>File Name</th>
                                        <th>Total Count</th>
                                        <th>Total Amount</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ecsdata && ecsdata.length > 0 ? (
                                        ecsdata.map((e, index) => (
                                            <tr key={index}>
                                                <td> <input type="radio" name="selectedFile" checked={selectedFile === e.FileName} onChange={() => handleSelect(e.FileName)} /> </td>
                                                <td>{index + 1}</td>
                                                {/* <td> <a href={`${apiurl}/UploadedBillsFiles/${e.FileName}`} target="_blank" rel="noreferrer" >  {e.FileName} </a> </td> */}
                                                <td>{e.FileName}</td>
                                                <td>{e.Total_Bidder_Count}</td>
                                                <td>{e.Total_ecs_Amount}</td>
                                                <td> {e.File_Upload_Date?.split('.')[0].replace('T', ' ')}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" style={{ textAlign: 'center' }}> No ECS files found </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ECSTransferFiles;